'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _bTickerMStateEmpty = (require('./../../ticker/ticker.react.js').default || require('./../../ticker/ticker.react.js')).applyDecls();

var _bTickerMStateEmpty2 = _interopRequireDefault(_bTickerMStateEmpty);

void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _iBem.declMod)(function (_ref) {
    var hasTicker = _ref.hasTicker,
        tickerCount = _ref.tickerCount;

    return hasTicker || tickerCount;
}, {
    block: 'user-account',
    content: function content(_ref2) {
        var tickerCount = _ref2.tickerCount,
            tickerMaxCount = _ref2.tickerMaxCount,
            children = _ref2.children;

        if (children) {
            return children;
        }

        var block = this.block;


        return [].concat(_toConsumableArray(this.__base.apply(this, arguments)), [_react2.default.createElement(_bTickerMStateEmpty2.default, { key: 'ticker', mix: { block: block, elem: 'ticker' }, count: tickerCount,
            maxCount: tickerMaxCount })]);
    }
}, {
    propTypes: {
        hasTicker: _propTypes2.default.bool,
        tickerCount: _propTypes2.default.number
    }
});